import { render, staticRenderFns } from "./SolicitaAtencion.vue?vue&type=template&id=7222c4e6&scoped=true"
import script from "./SolicitaAtencion.vue?vue&type=script&lang=ts"
export * from "./SolicitaAtencion.vue?vue&type=script&lang=ts"
import style0 from "./SolicitaAtencion.vue?vue&type=style&index=0&id=7222c4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222c4e6",
  null
  
)

export default component.exports